import {Injectable } from '@angular/core';

@Injectable()
export class SortService {
  public static SORT_ORDER_ASCENDING = 1;
  public static SORT_ORDER_DESCENDING = 0;

  public sortFilter(inputs: any, sortOrder: number, sortField: string) {
    if (sortOrder === 0 || sortField === undefined || sortField === null || sortField === '') {
      return inputs;
    }

    if (sortOrder === 1) {
      return inputs.sort((a, b) => this.ascending(a, b, sortField));
    } else {
      return inputs.sort((a, b) => this.descending(a, b, sortField));
    }
  }

  private ascending(a, b, sortField) {
    if (!a[sortField] && !b[sortField]) {
      return 0;
    } else if (!a[sortField]) {
      return -1;
    } else if (!b[sortField]) {
      return 1;
    }

    if (a[sortField] < b[sortField]) {
      return -1;
    }

    if (a[sortField] > b[sortField]) {
      return 1;
    }

    return 0;
  }

  private descending(a, b, sortField) {
    if (!a[sortField] && !b[sortField]) {
      return 0;
    } else if (!a[sortField]) {
      return 1;
    } else if (!b[sortField]) {
      return -1;
    }

    if (a[sortField] > b[sortField]) {
      return -1;
    }

    if (a[sortField] < b[sortField]) {
      return 1;
    }

    return 0;
  }
}
